import { UnsupportedTokenVersionError } from './types'
import type { SessionStrategy } from './types'
import { createTokenV1V2Strategy } from './websocket/strategies/token-v1v2'
import { createTokenV3Strategy } from './websocket/strategies/token-v3'

const STRATEGIES: Partial<Record<number, () => SessionStrategy>> = {
    1: createTokenV1V2Strategy,
    2: createTokenV1V2Strategy,
    3: createTokenV3Strategy,
}

export const resolveStrategy = (version: unknown): SessionStrategy => {
    // object keys are strings, so a lookup with a string version would hit a numeric entry
    if (typeof version !== 'number' || !Number.isInteger(version)) {
        throw new UnsupportedTokenVersionError(version)
    }

    const factory = STRATEGIES[version]

    if (!factory) {
        throw new UnsupportedTokenVersionError(version)
    }

    return factory()
}
